import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import styles from './JobCard.module.scss';
import { Briefcase, CircleCheckBig, Clock, Eye, UserCheck } from 'lucide-react';
import StatusBadge from 'components/ClientATS/StatusBadge/StatusBadge';

const formatPostedDate = (timestamp) => {
  if (!timestamp) return '';
  return `Posted ${moment(timestamp).format('MMM D, YYYY')}`;
};

const JobCard = ({ brief }) => {
  return (
    <Link to={brief.links?.ats_main_relative || '#'} className={styles.jobCard}>
      <div className={styles.jobCardContent}>
        <div className={styles.jobCardHeader}>
          <div className={styles.jobCardHeaderContent}>
            <h3 className={styles.jobCardTitle}>{brief.text}</h3>
            <div className={styles.jobCardMeta}>
              <Clock width={16} height={16} />
              <span>{formatPostedDate(brief.timestamp)}</span>
            </div>
          </div>
          <StatusBadge status={brief.status} />
        </div>
        <p className={styles.jobCardDescription}>{brief.description}</p>
      </div>
      <div className={styles.jobCardStats}>
        <div className={styles.jobCardStat}>
          <div className={`${styles.jobCardStatIcon} ${styles.iconBlue}`}>
            <Briefcase width={16} height={16} />
          </div>
          <div>
            <div className={styles.jobCardStatLabel}>Applied</div>
            <div className={styles.jobCardStatValue}>
              {brief.stats?.applied || 0}
            </div>
          </div>
        </div>
        <div className={styles.jobCardStat}>
          <div className={`${styles.jobCardStatIcon} ${styles.iconOrange}`}>
            <Eye width={16} height={16} />
          </div>
          <div>
            <div className={styles.jobCardStatLabel}>Reviewed</div>
            <div className={styles.jobCardStatValue}>
              {brief.stats?.reviewed || 0}
            </div>
          </div>
        </div>
        <div className={styles.jobCardStat}>
          <div className={`${styles.jobCardStatIcon} ${styles.iconPurple}`}>
            <UserCheck width={16} height={16} />
          </div>
          <div>
            <div className={styles.jobCardStatLabel}>Shortlisted</div>
            <div className={styles.jobCardStatValue}>
              {brief.stats?.shortlisted || 0}
            </div>
          </div>
        </div>
        <div className={styles.jobCardStat}>
          <div className={`${styles.jobCardStatIcon} ${styles.iconGreen}`}>
            <CircleCheckBig width={16} height={16} />
          </div>
          <div>
            <div className={styles.jobCardStatLabel}>Hired</div>
            <div className={styles.jobCardStatValue}>
              {brief.stats?.hired || 0}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

JobCard.propTypes = {
  brief: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    description: PropTypes.string,
    timestamp: PropTypes.string,
    status: PropTypes.string,
    links: PropTypes.shape({
      ats_main_relative: PropTypes.string,
    }),
    stats: PropTypes.shape({
      invited: PropTypes.number,
      applied: PropTypes.number,
      reviewed: PropTypes.number,
      shortlisted: PropTypes.number,
      declined: PropTypes.number,
      hired: PropTypes.number,
    }),
  }).isRequired,
};

export default JobCard;
